import authReducer from './authReducer';
import profileReducer from './profileReducer';
import signupReducer from './signupReducer';
import errorReducer from './errorReducer';
import usersReducer from './usersReducer';
import costReducer from './costReducer';
import costChartReducer from './costChartReducer';
import { reducer as formReducer } from 'redux-form';
import surveyReducer from './surveyReducer';
import valueReducer from './valueReducer';
import productReducer from './productReducer';
import presentationReducer from './presentationReducer';
import interviewReducer from './interviewReducer';

const reducers = {
    form: formReducer,
    auth: authReducer,
    error: errorReducer,
    profile: profileReducer,
    signup: signupReducer,
    users: usersReducer,
    cost: costReducer,
    costChart: costChartReducer,
    survey: surveyReducer,
    value: valueReducer,
    product: productReducer,
    presentation: presentationReducer,
    interview: interviewReducer,
};

export default reducers